import React from "react";

import ProtectedRoute from "../../components/ProtectedRoute";
import PageHeader from "../../components/PageHeader";
import InvoicesTable from "./InvoicesTable";

import styles from "./Invoices.module.css";

function Invoices() {
  return (
    <div className={styles.container}>
      <PageHeader title="Invoices" subtitle="Invoices linked to component orders" />

      <ProtectedRoute requiredAnyRole={["admin", "manager", "technician", "viewer"]}>
        <div className={styles.invoicesSection}>
          <div className={styles.sectionHeader}>
            <h2 className={styles.sectionTitle}>All Invoices</h2>
          </div>
          <div className={styles.tableContainer}>
            <InvoicesTable />
          </div>
        </div>
      </ProtectedRoute>
    </div>
  );
}

export default Invoices;
